<div class="dialog-header">
  <h3>{{ title }}</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    cdkFocusInitial
    (click)="closeDialog(false)"
  >
    <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
  </button>
</div>

<div class="dialog-content">
  <form [formGroup]="form">
    <div class="row-fx-legacy">
      <mat-form-field>
        <mat-label>{{ "input-reason" | translate }}</mat-label
        ><mat-select
          #select
          formControlName="reason"
          multiple
          (selectionChange)="selectReason($event)"
        >
          <mat-option *ngFor="let reason of reasons" [value]="reason.value">
            {{ reason.name }}
          </mat-option>
        </mat-select>
        <mat-error
          translate
          *ngIf="
            form.get('reason').touched &&
            form.get('reason').hasError('required')
          "
          >required-reason</mat-error
        >
      </mat-form-field>
    </div>

    <div class="row-fx-legacy" *ngIf="showTextArea">
      <mat-form-field>
        <mat-label>{{ "another-reason" | translate }}</mat-label
        ><textarea
          formControlName="otherReason"
          matInput
          matTextareaAutosize
          maxlength="255"
        ></textarea>
        <mat-error
          translate
          *ngIf="
            form.controls.otherReason.touched &&
            form.controls.otherReason.hasError('required')
          "
          >required-reason
        </mat-error>

        <mat-error
          translate
          *ngIf="
            form.get('otherReason').touched &&
            form.get('otherReason').hasError('minlength')
          "
        >
          another-reason-length</mat-error
        >
      </mat-form-field>
    </div>
  </form>
</div>
<div class="dialog-actions">
  <button
    [disabled]="form.invalid"
    mat-raised-button
    color="primary"
    (click)="closeDialog(true)"
  >
    {{ "input-save" | translate }}
  </button>
</div>
